import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  FormControlLabel,
  Switch,
  TableContainer,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ConfirmationModal from "views/components/ConfirmationModal";
import ToastModal from "views/components/ToastModal";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { calculateAge } from "utils/Utils";
import { useNavigate, useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import Table from "components/UpdateUi/Table/Table";
import { insuranceTableColumns } from "assets/properties/properties";
import CustomeSelectNew from "components/UpdateUi/CustomeSelect.js";
import { preferredLanguageData } from "assets/properties/properties";
import { insuranceEligibilityData } from "assets/properties/properties";
import { headerLabel } from "assets/properties/properties";
import { loanApplicationStatusNamesList } from "assets/properties/properties";
import { checkForRepledgeAccount } from "utils/Utils";
import { APPLICATION_TYPE_RE_PLEDGE } from "assets/properties/properties";
import { insurancePaymentMethod } from "assets/properties/properties";
import checkNegativeProfileApi from "../Applicant/CheckNegativeProfileApi";

const InsuranceEligibility = ({
  setNext,
  setBack,
  classes,
  esingDisable,
  mobileNum,
  closeModal,
  loanApplicationId,
  editable,
  featureFlags,
  loanType,
  prePledgeLoan
}) => {
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const { authToken } = useSelector((state) => state.login.authData);
  const [premiumData, setPremiumData] = useState({});
  const [isInsurance, setIsInsurance] = useState(true);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [confirmationModal1, setConfirmationModal1] = useState(false);
  const [confirmationModalHeader1, setConfirmationModalHeader1] = useState("");
  const [confirmationModalMsg1, setConfirmationModalMsg1] = useState("");
  const [riskPresent,setRiskPresent] = useState(false);
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [insuranceAmount, setInsuranceAmount] = useState("");
  const [maxEligibleSumInsuredValue,setMaxEligibleSumInsuredValue] = useState("");
  const [age, setAge] = useState("");
  const [disbursalAmount, setDisbursalAmount] = useState("");
  const [applicantData, setApplicantData] = useState({});
  const [panNumber, setPanNumber] = useState("");
  const [panName, setPanName] = useState("");
  const [loanAPPLICATIONID, setLoanAPPLICATIONID] = useState("");
  const outletData = featureFlags;
  const [panDisabled, setPanDisabled] = useState(false)
  const [showSubmitButton, setShowSubmitButton]= useState(false);
  const [isInsuranceLetterPresent,setIsInsuranceLetterPresent]=useState(false);
  const enabledPanVerifiedFlag = parseAndSetFlag(
    outletData.enabledPanVerifiedFlag
  );
    const enableNegativeProfileCheck = parseAndSetFlag(outletData?.enableCheckNegativeProfile);
  
  const [disableApplicantName, setDisableApplicantName] = useState(true);
  const [disableNext, setDisableNext]=useState(false)
  const [tableData, setTableData] = useState([]);
  const [preferredLanguageSelect, setPreferredLanguage]=useState(preferredLanguageData?.[0]?.code)
  // const [paymentMode,setPaymentMode] = useState('');
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const handleInsuranceSwitch = () => {
    setIsInsurance((prev) => !prev);
  };
  const [panThirdPartyPanEnabled, setThirdPartyPanEnabled]=useState(false)
  const GetThirdPartyData = async () => {
    const result = await apiHandler({
      url: endpoint.CHECK_THIRD_PARTY_INTEGRATION,
      authToken: authToken,
    });
    const isPanEnabled = Array.isArray(result?.data) 
    ? result.data.some(integration => integration?.integration === 'PAN' && integration?.enabled)
    : false;
    setThirdPartyPanEnabled(isPanEnabled);
  };
  const getSumInsuredValues = async(personAge) => {
    const result = await apiHandler({
      url: endpoint.GET_ALL_SUM_INSURED_VALUES,
      authToken: authToken,
    });
    if(result?.data?.error_code){
      toastUpdate("Error",result?.data?.user_description,true);
    }else{
      const data = result?.data;
    const matchedRange = data.find(item => 
      personAge >= item.minAge && personAge <= item.maxAge
    );

    if (matchedRange) {
      const sumInsured = matchedRange.sumInsured;
      setMaxEligibleSumInsuredValue(sumInsured);
    } else {
      setMaxEligibleSumInsuredValue(0);
    }
    }
  }
  useEffect(()=>{
    if(isInsurance){
      GetSanctionLetterDetails();
      GetPremium()
      setShowSubmitButton(false)
    }else{
      handleCalculatePremium("noinsurance")
      setDisableNext(false)
    }
  },[isInsurance])
  const GetPremium = async () => {
    setCallInProgress(true);
    //DISBURSAL_GETDATA
    const res = await apiHandler({
      url: endpoint.GET_INSURANCE_PREMIUM + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      GetDisbursalDetails(insuranceEligibilityData?.updated);
    }else if (res?.data === ''){
      GetDisbursalDetails(insuranceEligibilityData?.updated);
    } else {
      GetDisbursalDetails();
      setInsuranceAmount(res?.data?.sumInsured);
      setPremiumData(res?.data);
      setHeight(res?.data?.applicantHeight || '');
      setWeight(res?.data?.applicantWeight || '');
      setDisbursalAmount(res?.data?.sumInsured);
      setPreferredLanguage(res?.data?.preferredLanguage || "English")
      // setPaymentMode(res?.data?.paymentMode || "")
      setTableData([
        {
          suminsured: res?.data.sumInsured,
          premium: res?.data.premium,
          gst: res?.data.gst,
          totalPremium: res?.data.totalPremium,
        },
      ]);
    }
  };

  const GetSanctionLetterDetails = async () => {
    setCallInProgress(true)
    const loanAccountNumber = loanApplicationId
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanAccountNumber,
      method: "GET",
      authToken: authToken,
    })
    setCallInProgress(false);
    if (res?.data?.insuranceLetterLink) {
      setIsInsuranceLetterPresent(true);
    } else{
      setIsInsuranceLetterPresent(false);
    }
  };

  const handleCalculatePremium = async (noInsurance) => {
    setCallInProgress(true);
    //SANCTIONLETTER_UPDATE
    const res = await apiHandler({
      url: endpoint.CALCULATE_INSURANCE_PREMIUM + loanApplicationId,
      method: "POST",
      authToken: authToken,
      data: {
        applicantHeight: noInsurance === "noinsurance" ? 0 : height,
        applicantWeight: noInsurance === "noinsurance" ? 0 : weight,
        preferredLanguage: preferredLanguageSelect,
        insuranceRequired: noInsurance === "noinsurance" ? false : true,
        sumInsured: insuranceAmount,
        // paymentMode:paymentMode,
      },
    });
    setCallInProgress(false);
    //this.setState({ callInProgress: false });
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      setShowSubmitButton(true)
      return;
    } else {
      if(isInsurance){
      if (Number(res?.data?.sumInsured) === 0) {
        setShowSubmitButton(true)
        toastUpdate(
          "Error",
          "You are not eligible for the insurance",
          true
        );
      } else {
        setShowSubmitButton(false)
        setPremiumData(res?.data);
        setTableData([
          {
            suminsured: res?.data.sumInsured,
            premium: res?.data.premium,
            gst: res?.data.gst,
            totalPremium: res?.data.totalPremium,
          },
        ]);
      }
    }
    }
  };
  const GetDisbursalDetails = async (type) => {
    setCallInProgress(true);
    //DISBURSAL_GETDATA
    const res = await apiHandler({
      url: endpoint.ORNAMENT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      setDisbursalAmount(res?.data?.actualLoanAmount);
      if(type === 'update'){
        setInsuranceAmount(res?.data?.actualLoanAmount);
      }
      GetApplicantDetails();
    }
  };
  const GetApplicantDetails = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.APPLICANT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      setApplicantData(res.data);
      setAge(res.data?.dob);
      setPanNumber(res?.data?.panNumber);
      setPanName(res?.data?.nameOnPanCard);
      if(res?.data?.panNumber && res?.data?.nameOnPanCard){
        setPanDisabled(res?.data?.panNumber)
      }
      await GetThirdPartyData()
        const personAge = calculateAge(res?.data?.dob);
        await getSumInsuredValues(personAge);
    }
  };

  const GetProfileData = async (verified) => {
    if(verified && enableNegativeProfileCheck){
      const apiReponse = await checkNegativeProfileApi(apiHandler,
      endpoint,
      authToken,
      setCallInProgress,
      toastUpdate,
      null,
      panNumber,)
      console.log("apiReponse", apiReponse)
      if (apiReponse?.[0]?.risk) {
        proceedApplication1();
      }
    }
    setCallInProgress(true);
    const queryParams = !verified ? mobileNum : `${mobileNum?.trim()},${panNumber?.trim()}`;;
    const res = await apiHandler({
      url: endpoint.SEARCH_PROFILE + queryParams,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!res?.data?.error_code) {
      const customerIds = res?.data?.map((customer) => customer?.customerId);
      const customerIdsString = customerIds?.join(", ");
      const errorMessage = verified
        ? "Pan is Linked with other customer"
        : `Multiple Customer id ${customerIdsString} exists with same mobile number. Kindly correct the same before new loan creation.`;
      if (res?.data?.length > 1) {
        toastUpdate("Error", errorMessage, true);
        setDisableNext(true);
      } else if (res?.data?.length === 1) {
        setDisableNext(false)
        verifyPAN();
      }
    } else {
      setDisableNext(false)
      verifyPAN();
    }
  };

  const verifyPAN = async () => {
    setCallInProgress(true);
    const response = await apiHandler({
      url: endpoint.NEW_PAN_CARD_VERIFY,
      authToken: authToken,
      method: "POST",
      data: {
        panNumber: panNumber?.toUpperCase(),
        dob:applicantData?.dob,
        name:applicantData?.nameOnAdhaar,
      },
    });
    setCallInProgress(false);
    if (
      (response?.data?.error_code ||
        response?.data?.name?.trim() === "" ||
        !response?.data ||
        response?.data?.name === null ||
        !response) &&
        !panThirdPartyPanEnabled
    ) {
      setDisableApplicantName(false);
    } else if (response?.data?.error_code) {
      setPanNumber("");
      setDisableApplicantName(true);
      toastUpdate("Error", response?.data?.user_description, true);
      return;
    } else if (response?.data?.name?.trim() === "") {
      setDisableApplicantName(true);
    } else {
      setPanName(response.data.name);
      setPanNumber(response.data.panCard);
      setDisableApplicantName(true);
    }
  };

  const onClickProceedData = async (id) => {
    setCallInProgress(true);
    if (loanType === APPLICATION_TYPE_RE_PLEDGE) {
      const checkResult = await checkForRepledgeAccount(authToken, prePledgeLoan);
      if(checkResult?.data?.error_code){
        toastUpdate("Error",checkResult?.data?.user_description,true);
        return;
      }else{
        const filteredData = checkResult?.data?.filter(item => Number(item?.id) !== Number(id)) || [];
        if (Array.isArray(filteredData) && filteredData.length > 0) {
          const ids = filteredData
            .map(item => item?.id)
            .filter(Boolean);
          const idsText = ids.length > 0 ? ` Lead Ids: ${ids.join(", ")}` : "";
          toastUpdate(
            "Error",
            `Already Repledge Loan Present with ${idsText}`,
            true
          );
          return false;
        }
      }
  }
    const result = await apiHandler({
      url: endpoint.DISBURSAL_APPLICATION_LMS + id + `?newDisbursement=true`,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);;
    } else {
        navigate("/loanservice/disbursLms", { state: { from: '' } });
    }
  };
  const proceedApplication = () => {
          if(isInsurance){
    if(height && weight && Object.keys(premiumData).length > 0 && panName && typeof panName !== 'undefined' && panName !== null && panNumber && typeof panNumber !== 'undefined' && panNumber !== null){
      saveApplicantInfo()
    }else{
      if(Object.keys(premiumData).length === 0 || premiumData?.applicantHeight === 0 || premiumData?.applicantWeight === 0){
      toastUpdate("Error", "Please calculate the premium", true);
      }else if((!panName || typeof panName === 'undefined' || panName === null) || (!panNumber || typeof panNumber === 'undefined' || panNumber === null)){
        toastUpdate("Error", "Please verify the pan number", true);
      // }else if(!paymentMode && typeof paymentMode !== 'undefined' && paymentMode !== null ){
      //    toastUpdate("Error", "Please Select the payment mode", true);
      }
    }}else{
          setNext()
    }
  };

  const onSubmitProceedApplication = () =>{
    setConfirmationModalHeader("Disbursal");
    setConfirmationModalMsg(
      "Are you sure you want to Proceed this Loan to LMS"
    );
    setConfirmationModal(true);
    setLoanAPPLICATIONID(loanApplicationId);
  }
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setLoanAPPLICATIONID("");
  };
  const handlePositiveResponse = async () => {
    let id = loanAPPLICATIONID;
    handleNegativeResponse();
    // Call API to delete loanMarking
    onClickProceedData(id);
  };
  const closeConfirmationModal = () => {
      setConfirmationModal1(false);
      setConfirmationModalHeader1("");
      setConfirmationModalMsg1("");
    };

    const handleNegativeResponse1 = () => {  
    closeConfirmationModal();
      setRiskPresent(true);
    };

    const handlePositiveResponse1 = () => {  
    closeConfirmationModal();
    setRiskPresent(false);
    };
    const proceedApplication1 = () => {
      setConfirmationModalHeader1("Risk Warning");
      setConfirmationModalMsg1(
        "Customer is in negative list, Do you want to proceed"
      );
      setConfirmationModal1(true);
    };
  const handleChangePan = (e) => {
    setPanNumber(e?.toUpperCase());
  };

  const setHandleHeight = (e) => {
    setPremiumData({});
    const regex = /^\d*\.?\d*$/; // Allows digits and a single decimal point
    if (e === "" || regex.test(e)) {
      setHeight(e);
    }
  };
  const setHandleWeight = (e) => {
    setPremiumData({});
    const regex = /^\d*\.?\d*$/; // Allows digits and a single decimal point
    if (e === "" || regex.test(e)) {
      setWeight(e);
    }
  };
  // const handlePaymentMode = (e) => {
  //   setPremiumData({});
  //   setPaymentMode(e);
  // };
  const setHandleInsuranceAMount = (e) => {
    setPremiumData({});
    const regex = /^\d*\.?\d*$/; // Allows digits and a single decimal point
    if (e === "" || regex.test(e)) {
      setInsuranceAmount(e);
    }
  };

  const saveApplicantInfo = async ()=> {
    setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.ADMIN_APPLICANT_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          loanApplicationId: loanApplicationId,
          email: applicantData?.email,
          panNumber: panNumber && panNumber !== "" ? panNumber : null,
          nameOnPanCard: panName && panName !== "" ? panName : null,
          adhaarNumber:applicantData?.adhaarNumber,
          nameOnAdhaar:applicantData?.nameOnAdhaar
              ? applicantData?.nameOnAdhaar
              : panName,
          dob: applicantData?.dob,
          fatherName:applicantData?.fatherName,
          dueDiligence:applicantData?.dueDiligence,
          addresses: [
            {
              addressType: "PERMANENT_ADDRESS",
              houseNumber:applicantData?.addresses?.[0]?.houseNumber,
              street: applicantData?.addresses?.[0]?.street,
              locality: applicantData?.addresses?.[0]?.locality,
              postOffice: applicantData?.addresses?.[0]?.postOffice,
              villageTownCity:applicantData?.addresses?.[0]?.villageTownCity,
              state: applicantData?.addresses?.[0]?.state,
              district: applicantData?.addresses?.[0]?.district,
              pincode: applicantData?.addresses?.[0]?.pincode,
            },
            {
              addressType: "RESIDENTIAL_ADDRESS",
              houseNumber: applicantData?.addresses?.[1]?.houseNumber,
              street: applicantData?.addresses?.[1]?.street,
              locality:applicantData?.addresses?.[1]?.locality,
              postOffice: applicantData?.addresses?.[1]?.postOffice,
              villageTownCity: applicantData?.addresses?.[1]?.villageTownCity,
              state: applicantData?.addresses?.[1]?.state,
              district: applicantData?.addresses?.[1]?.district,
              pincode:applicantData?.addresses?.[1]?.pincode,
            },
          ],
          documentName: applicantData?.documentName,
          documentNumber: applicantData?.documentNumber,
          alternateMobileNumber: applicantData?.alternateMobileNumber,
          gender: applicantData?.gender,
          occupationType: applicantData?.occupationType,
          purposeOfLoan: applicantData?.purposeOfLoan,
          gstNumber: applicantData?.gstNumber,
          gstState: applicantData?.gstState,
          sameAddress: applicantData?.sameAddress,
          adhaarAvailable: applicantData?.adhaarAvailable,
          spouseName: applicantData?.spouseName,
          maritalStatus: applicantData?.maritalStatus,
          memberCount: applicantData?.memberCount,
          applicantAnnualIncome: applicantData?.applicantAnnualIncome,
          motherName: applicantData?.motherName,
          applicantNamePrefix: applicantData?.applicantNamePrefix,
          documentExpiry: applicantData?.documentExpiry,
          customerId: applicantData?.customerId,
          loanAccountNumber: applicantData?.loanAccountNumber,
          branchCode: applicantData?.branchCode,
        },
      });
      //this.setState({ -: false });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        savePanDetails();
      }
  }

  const savePanDetails = async () => {
    const res = await apiHandler({
      url: endpoint.UPDATE_CUSTOMER_PAN_DETAILS + `${applicantData?.customerId}/update`,
      method: "PUT",
      authToken: authToken,
      data: {
        panNumber: panNumber && panNumber !== "" ? panNumber : null,
        nameOnPanCard: panName && panName !== "" ? panName : null,
      }
  });
  if (res?.data?.error_code && res?.data?.error_code === 403) {
    toastUpdate("Error", res?.data?.user_description, true);
    return;
  } else if (res?.data?.error_code) {
    toastUpdate("Error", res?.data?.user_description, true);
    return;
  } else {
    toastUpdate("Success", "Create Applicant successfully", true);
    setNext();
  }
  }
const handleNext=()=>{
    if(height && weight && Object.keys(premiumData).length > 0 && panName && panNumber){
      saveApplicantInfo();
    }else{
      if(Object.keys(premiumData).length === 0 ){
      toastUpdate("Error", "Please calculate the premium", true);
      }else if(!panName || !panNumber){
        toastUpdate("Error", "Please verify the pan number", true);
      }
      
    }
}
  const handleInsuranceAmount = async (e) => {
    const insuranceAmount = Number(e);
    const maxEligible = Number(maxEligibleSumInsuredValue);
    const actualLoan = Number(disbursalAmount);

    if (isNaN(insuranceAmount)) {
      toastUpdate('Error', 'Invalid input: not a number');
    }
    if(actualLoan > Number(outletData?.insuranceAmountFlag) && insuranceAmount < Number(outletData?.insuranceAmountFlag)){
        toastUpdate('Error', `Insured Amount can't be less than (${Number(outletData?.insuranceAmountFlag)})`,true);
        setInsuranceAmount(Number(outletData?.insuranceAmountFlag));
    }
    if (maxEligible > actualLoan) {
      if (insuranceAmount > actualLoan) {
        toastUpdate('Error', `Insured Amount can't be greater than Actual Loan Amount (${actualLoan})`,true);
        setInsuranceAmount('');
      }
    } else {
      if (insuranceAmount > maxEligible) {
        toastUpdate('Error', `Insured Amount can't be greater than Max Eligible Sum Insured (${maxEligible})`,true);
        setInsuranceAmount('');
      }
    }
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        <SubHeader
           label={headerLabel?.insuranceEligiblity}
            subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
            onlyLabel/>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 40 }}>
        <Grid container>
          <Grid item xs={12} md={8} style={{ textAlign: "start" }}>
            <label style={{ marginRight: "10px", color: "black" }}>
              ⁠Do you want insurance?
            </label>
            <label style={{ marginRight: "15px", color: "black" }}>No</label>
            <FormControlLabel
              control={
                <Switch
                  checked={isInsurance}
                  onChange={handleInsuranceSwitch}
                  color="primary"
                  disabled={!editable}
                />
              }
            />
            <label style={{ marginLeft: "15px", color: "black" }}>Yes</label>
          </Grid>
          {isInsurance && ( <Grid
                item
                xs={12}
                md={4}
                className={classes.fieldContaienr}
                style={{margin:'0px', textAlign:'left'}}
              >
                <Button
                  size="small"
                  className={classes.nextButton}
                  disabled={callInProgress || height === "" || weight === "" || !editable || isInsuranceLetterPresent }
                  onClick={handleCalculatePremium}
                  style={{ width: "60%" }}
                >
                  Calculate
                </Button>
              </Grid> )}
        </Grid>
        {isInsurance && (
          <>
          <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
            <Grid container className={classes.inputFieldContainer}>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomeTextField
                  label="Height (cm))"
                  required
                  id="height"
                  value={height}
                  setState={setHandleHeight}
                  // maxLength="3"
                  disabled={!editable || isInsuranceLetterPresent}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomeTextField
                  label="Weight (kg)"
                  required
                  id="weight"
                  value={weight}
                  setState={setHandleWeight}
                  // maxLength="3"
                  disabled={!editable || isInsuranceLetterPresent}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Preferred Language (Sign as per PAN)*"
              value={preferredLanguageSelect}
              id="document_name"
              setState={setPreferredLanguage}
              data={preferredLanguageData}
              type="type"
              disabled={!editable || isInsuranceLetterPresent}
            />
          </Grid>
          <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomeTextField
                  label="Insurance Amount"
                  required
                  id="insurance_amount"
                  value={insuranceAmount}
                  setState={setHandleInsuranceAMount}
                  setBlur={handleInsuranceAmount}
                  disabled={!editable || isInsuranceLetterPresent || disbursalAmount <= Number(outletData?.insuranceAmountFlag)}
                />
              </Grid>
              {/* <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
                <CustomeSelectNew
                  label="Paymnet Mode*"
                  value={paymentMode}
                  id="paymnet_mode"
                  setState={handlePaymentMode}
                  data={insurancePaymentMethod}
                  type="type"
                  disabled={!editable || isInsuranceLetterPresent}
                />
              </Grid> */}
            </Grid>
          </Grid>
         {Number(premiumData?.sumInsured) > 0 && (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={classes.inputContainer}
            >
              <Grid container className={classes.inputFieldContainer}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={classes.fieldContaienr}
                >
                  <CustomeTextField
                    label="Bmi"
                    id="bmi"
                    value={premiumData?.bmi}
                    setState={setAge}
                    // maxLength="3"
                    disabled
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={classes.fieldContaienr}
                >
                  <CustomeTextField
                    label="Age"
                    id="age"
                    value={calculateAge(age)}
                    setState={setAge}
                    maxLength="3"
                    disabled
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={classes.fieldContaienr}
                >
                  <CustomeTextField
                    label="Loan Amount"
                    id="amount"
                    value={disbursalAmount}
                    setState={setDisbursalAmount}
                    disabled
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={classes.inputContainer}
            >
              <Grid container className={classes.inputFieldContainer}>
                <Grid
                  xs={12}
                  sm={6}
                  md={4}
                  className={classes.fieldContaienr}
                  style={{ position: "relative" }}
                >
                  <CustomeTextField
                    label="PAN No."
                    required
                    id="pan_number"
                    value={panNumber?.toUpperCase()}
                    setState={handleChangePan}
                    type="notCapital"
                    maxLength="10"
                    disabled={!editable || panDisabled}
                  />
                  <Button
                    style={{
                      height: "40px",
                      width: "75px",
                      position: "absolute",
                      right: 0,
                      top: 0,
                      margin: 0,
                    }}
                    size="small"
                    disabled={
                      panNumber === "" ||
                      typeof panNumber === "undefined" ||
                      panNumber === null || !editable || panDisabled
                    }
                    onClick={() => GetProfileData("clickable")}
                    className={classes.nextButton1}
                  >
                    verify
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={classes.fieldContaienr}
                >
                  <CustomeTextField
                    label="Applicant Name"
                    required
                    id="applicant_name"
                    value={panName}
                    setState={setPanName}
                    disabled={disableApplicantName}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={classes.inputContainer}
              style={{ maxWidth: "1100px", margin: "50px auto" }}
            >
              <TableContainer>
                <Table
                  columns={insuranceTableColumns}
                  rows={tableData}
                  styles="style"
                />
              </TableContainer>
            </Grid>
          </>
        )}
        </>
      )}
        <Grid container>
          <Grid
            item
            xs={12}
            style={{ textAlign: window.innerWidth < 360 ? "center" : "right" }}
          >
            <Button
              size="small"
              className={classes.nextButton1}
              onClick={setBack}
            >
              Back
            </Button>
            <Button
              size="small"
              className={classes.nextButton}
              disabled={callInProgress || disableNext}
              onClick={() => proceedApplication()}
            >
                {"Next"} 
            </Button> 
          </Grid>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
        />
      )}
      {confirmationModal1 && (
        <ConfirmationModal
          confirmationModal={confirmationModal1}
          confirmationModalHeader={confirmationModalHeader1}
          confirmationModalMsg={confirmationModalMsg1}
          handleNegativeButton={handleNegativeResponse1}
          handlePositiveButton={handlePositiveResponse1}
        />
      )}
    </Grid>
  );
};

InsuranceEligibility.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  esingDisable: PropTypes.bool,
};

export default InsuranceEligibility;
